import { Injectable } from '@angular/core';
import { LocalStorageUtilities } from '@app/utilities/local-storage-utilities';
import { PersonPortalState } from '@app/models/person-portal-state';
import { AuthorizationService } from '@app/services/authorization.service';
import { LogEvent } from '@app/models/log-event';
import { HttpErrorResponse } from '@angular/common/http';
import { StringUtilities } from '@app/utilities/string-utilities';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor(private authorizationService: AuthorizationService, ) { }

  public logEvent(description: string, activityCode?: number, injectionText?: string, userId?: string) {

    let personPortalState: PersonPortalState = LocalStorageUtilities.getPersonPortalState();
    let logEvent: LogEvent = new LogEvent();
    logEvent.co = "H";
    // This test is needed because some logging events occur
    // before the user has been authenticated.
    if (userId === undefined) {
      logEvent.accountNumber = personPortalState.acctNum;
      logEvent.userName  = personPortalState.userName;
    } else {
      logEvent.userName = userId;
    }    
    if (injectionText != undefined) {
       description = StringUtilities.formatString(description, injectionText);
    }
    logEvent.activityCode = activityCode;
    logEvent.activityDescription = description;
    logEvent.activityTime = new Date();
    logEvent.userAgent = window.navigator.userAgent.trim();   
    this.authorizationService.saveLogEvent(logEvent).subscribe({
      next: (event: LogEvent) => {
        if (event) {
          console.log("Log activity description: "+event.activityDescription);
        }        
      },
      error: (err: HttpErrorResponse) => {
        console.log("Error in LogEvent method.");        
      }
    });
  }

  public logEventNoWebAuthentication(description: string, accountNum: string) {

    let personPortalState: PersonPortalState = LocalStorageUtilities.getPersonPortalState();
    let logEvent: LogEvent = new LogEvent();
    logEvent.co = "H";
    logEvent.accountNumber = accountNum;
    logEvent.activityDescription = description;
    logEvent.activityTime = new Date();
    logEvent.userAgent = window.navigator.userAgent.trim();
    // logEvent.webauthenticationId = personPortalState.webauthenticationId.id;

    this.authorizationService.saveLogEvent(logEvent).subscribe({
      next: (event) => {
        console.log("works so far.");
      }
    });
  }

}
